"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScannerStatusInfo = exports.ScanRequest = exports.ScanTypes = void 0;
var ScanTypes;
(function (ScanTypes) {
    ScanTypes[ScanTypes["NESSUSD"] = 0] = "NESSUSD";
    ScanTypes[ScanTypes["DEFAULT_SERVICE"] = 1] = "DEFAULT_SERVICE";
    ScanTypes[ScanTypes["DEFAULT_NUXEO"] = 2] = "DEFAULT_NUXEO";
})(ScanTypes = exports.ScanTypes || (exports.ScanTypes = {}));
class ScanRequest {
}
exports.ScanRequest = ScanRequest;
var ScannerStatusInfo;
(function (ScannerStatusInfo) {
    ScannerStatusInfo["STOPPED"] = "STOPPED";
    ScannerStatusInfo["ERROR"] = "ERROR";
    ScannerStatusInfo["TIMEOUT"] = "TIMEOUT";
    ScannerStatusInfo["FINISHED"] = "FINISHED";
    ScannerStatusInfo["CANCELED"] = "CANCELED";
    ScannerStatusInfo["STARTING"] = "STARTING";
    ScannerStatusInfo["RUNNING"] = "RUNNING";
})(ScannerStatusInfo = exports.ScannerStatusInfo || (exports.ScannerStatusInfo = {}));
//# sourceMappingURL=scanners.js.map